import { Action } from '@reduxjs/toolkit'
import { persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import { call, put, takeLatest } from 'redux-saga/effects'
import { MerchantModel } from '../models/MerchantModel'
import { FeePlanModel } from '../models/FeePlanModel'
import { VposModel } from '../models/VposModel'
import { BankAccountModel } from '../models/BankAccountModel'
import { ContactModel } from '../models/ContactModel'
import { getBanks, getContacts, getCustomerFeePlan, getFeePlan, getHashParam } from './MerchantCRUD'
export interface ActionWithPayload<T> extends Action {
    payload?: T
}
export const actionTypes = {
    SetMerchant: '[SetMerchant] Action',
    SetBankAccounts: '[SetBankAccounts] Action',
    SetContacts: '[SetContacts] Action',
    SetFeePlan: '[SetFeePlan] Action',
    SetCustomerFeePlan: '[SetCustomerFeePlan] Action',
    SetHashParam: '[SetHashParam] Action'
}

const initialMerchantState: IMerchantState = {
    merchant: undefined,
    bankAccounts: undefined,
    contacts: undefined,
    feePlan: undefined,
    customerFeePlan: undefined,
    hashParam: undefined
}

export interface IMerchantState {
    merchant?: MerchantModel
    bankAccounts?: BankAccountModel[]
    contacts?: ContactModel[]
    feePlan?: FeePlanModel
    customerFeePlan?: VposModel[]
    hashParam?: string
}

export const reducer = persistReducer(
    { storage, key: 'kpmrc-merchant', whitelist: ['merchant', 'feePlan', 'customerFeePlan'] },
    (state: IMerchantState = initialMerchantState, action: ActionWithPayload<IMerchantState>) => {
        switch (action.type) {
            case actionTypes.SetMerchant: {
                const merchant = action.payload?.merchant
                return { merchant, feePlan: undefined, customerFeePlan: undefined, bankAccounts: undefined, contacts: undefined, hashParam: undefined }
            }

            case actionTypes.SetBankAccounts: {
                const bankAccounts = action.payload?.bankAccounts
                return { ...state, bankAccounts }
            }

            case actionTypes.SetContacts: {
                const contacts = action.payload?.contacts
                return { ...state, contacts }
            }

            case actionTypes.SetFeePlan: {
                const feePlan = action.payload?.feePlan
                return { ...state, feePlan }
            }

            case actionTypes.SetCustomerFeePlan: {
                const customerFeePlan = action.payload?.customerFeePlan
                return { ...state, customerFeePlan }
            }

            case actionTypes.SetHashParam: {
                const hashParam = action.payload?.hashParam
                return { ...state, hashParam }
            }

            default:
                return state
        }
    }
)

export const actions = {
    setMerchant: (merchant: MerchantModel) => ({ type: actionTypes.SetMerchant, payload: { merchant } }),
    setBankAccounts: (bankAccounts: BankAccountModel[]) => ({ type: actionTypes.SetBankAccounts, payload: { bankAccounts } }),
    setContacts: (contacts: ContactModel[]) => ({ type: actionTypes.SetContacts, payload: { contacts } }),
    setFeePlan: (feePlan: FeePlanModel) => ({ type: actionTypes.SetFeePlan, payload: { feePlan } }),
    setCustomerFeePlan: (customerFeePlan: VposModel[]) => ({ type: actionTypes.SetCustomerFeePlan, payload: { customerFeePlan } }),
    setHashParam: (hashParam: string) => ({ type: actionTypes.SetHashParam, payload: { hashParam } }),
}

export function* saga() {
    yield takeLatest(actionTypes.SetMerchant, function* setMerchantSaga() {
        const { data: bankAccounts } = yield call(getBanks)
        const { data: contacts } = yield call(getContacts)
        const { data: feePlan } = yield call(getFeePlan)
        const { data: customerFeePlan } = yield call(getCustomerFeePlan)
        const { data: hashParam } = yield call(getHashParam)
        yield put(actions.setBankAccounts(bankAccounts.data))
        yield put(actions.setContacts(contacts.data))
        yield put(actions.setFeePlan(feePlan.data))
        yield put(actions.setCustomerFeePlan(customerFeePlan.data))
        yield put(actions.setHashParam(hashParam.data))

    })
}